module.exports = __webpack_public_path__ + "img/event-img-2.9fb117d9.jpg";